import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSubdomain } from '../utils/subdomainHelper';
import { admissionsService } from '../firebase/admissions';

/**
 * SubdomainRouter Component
 * Detects subdomain and redirects to the appropriate institution page
 */
const SubdomainRouter = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSubdomain = async () => {
      const subdomain = getSubdomain();
      
      // If no subdomain, just render children normally
      if (!subdomain) {
        setLoading(false);
        return;
      }

      try {
        // Try to find institution by subdomain
        const result = await admissionsService.getInstitutionBySubdomain(subdomain);
        
        if (result.success && result.institution) {
          // Redirect to institution landing page
          navigate(`/institute/${result.institution.id}`, { replace: true });
        } else {
          // Subdomain doesn't match any institution
          setError('Institution not found');
          setLoading(false);
        }
      } catch (err) {
        console.error('Error loading institution by subdomain:', err);
        setError('Error loading institution');
        setLoading(false);
      }
    };

    handleSubdomain();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Institution Not Found</h1>
          <p className="text-gray-600 mb-6">{error}</p>
          <a
            href={window.location.protocol + '//' + window.location.hostname.split('.').slice(-2).join('.')}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Main Site
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default SubdomainRouter;
